import { Project } from '../../types';

export interface ProjectMetadata {
  id: string;
  name: string;
  lastEdited: number;
  type: 'example' | 'user';
  sourceFile?: string;
}

export class MetadataStore {
  private static readonly KEY = 'railmapper_projects';
  private static readonly MAX_PROJECTS = 1000;

  static getProjects(): ProjectMetadata[] {
    const data = localStorage.getItem(this.KEY);
    return data 
      ? JSON.parse(data)
      : [];
  }

  static getProject(id: string): ProjectMetadata | null {
    const projects = this.getProjects();
    return projects.find(p => p.id === id) || null;
  }

  static updateProject(metadata: ProjectMetadata): void {
    const projects = this.getProjects()
      .filter(p => p.id !== metadata.id)
      .concat(metadata)
      .sort((a, b) => b.lastEdited - a.lastEdited)
      .slice(0, this.MAX_PROJECTS);

    localStorage.setItem(this.KEY, JSON.stringify(projects));
  }

  static deleteProject(id: string): void {
    const projects = this.getProjects()
      .filter(p => p.id !== id);
    
    localStorage.setItem(this.KEY, JSON.stringify(projects));
  }

  static getMostRecentProject(): ProjectMetadata | null {
    const projects = this.getProjects();
    if (projects.length === 0) {
      console.log('No projects found');
      return null;
    }

    // Sort projects by lastEdited (newest first)
    const sortedProjects = projects.sort((a, b) => b.lastEdited - a.lastEdited);
    const mostRecent = sortedProjects[0];
    
    console.log('Selected most recent project:', {
      id: mostRecent.id,
      name: mostRecent.name,
      type: mostRecent.type,
      lastEdited: new Date(mostRecent.lastEdited).toISOString()
    });

    return mostRecent;
  }

  // New method to get filtered projects by type
  static getProjectsByType(): { userProjects: ProjectMetadata[], exampleProjects: ProjectMetadata[] } {
    const projects = this.getProjects();
    return {
      userProjects: projects.filter(p => p.type === 'user'),
      exampleProjects: projects.filter(p => p.type === 'example')
    };
  }
} 